module.exports = __webpack_public_path__ + "img/0015.b06df265.gif";